const StatoDichiarazioneDaImportare = {
  NonPresente: 0,
  GiaPresente: 1,
  NonImportabile: 2,
};

const toString = (tipo) => {
  switch (tipo) {
    case StatoDichiarazioneDaImportare.GiaPresente:
      return 'Già presente';
    case StatoDichiarazioneDaImportare.NonImportabile:
      return 'Non importabile';
    default:
      return '';
  }
};

StatoDichiarazioneDaImportare.stringify = toString;

export default StatoDichiarazioneDaImportare;
